import { siteBrand, testimonials } from "@/mocks/news";

const principles = [
  { icon: "ri-shield-check-line", title: "只整理有出处的信息", desc: "没有可靠来源的说法不收录，官方口径优先。" },
  { icon: "ri-price-tag-3-line", title: "标注状态，不替你下结论", desc: "把进展节点摆清楚，判断留给你自己。" },
  { icon: "ri-user-heart-line", title: "尊重当事人", desc: "不涉及个人隐私，不做人身攻击式的表达。" },
  { icon: "ri-refresh-line", title: "持续更新，错了就改", desc: "信息变化随时修正，并保留修改痕迹。" },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <span className="text-xs font-semibold tracking-widest text-primary-600">ABOUT</span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              关于{siteBrand.name}
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">{siteBrand.intro}</p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              我们不追求把每件事说成结论，而是希望你在刷到一条消息时，能立刻知道它走到哪一步、下一步可能是什么。热度会过去，
              但清晰的时间线会留下来。
            </p>

            <div className="mt-6 overflow-hidden rounded-lg border border-background-200">
              <div className="h-[220px] w-full md:h-[260px]">
                <img
                  src="https://readdy.ai/api/search-image?query=abstract%20flat%20illustration%20of%20an%20editorial%20newsroom%20desk%20with%20stacked%20paper%20sheets%20and%20warm%20desk%20lamp%20glow%2C%20layered%20paper%20cut%20style%2C%20cream%20and%20amber%20and%20jade%20green%20palette%2C%20minimal%20geometric%20shapes%2C%20no%20text%2C%20calm%20organized%20composition&width=900&height=620&seq=about-newsdesk-02&orientation=landscape"
                  alt="抽象插画：编辑桌上叠放的稿件与暖色灯光，代表编辑部的内容整理工作"
                  className="h-full w-full object-top"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <h3 className="font-heading text-lg font-semibold text-foreground-950">内容原则</h3>
            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((item) => (
                <div key={item.title} className="rounded-lg border border-background-200 bg-background-100/60 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h4 className="mt-3 font-heading text-base font-semibold text-foreground-950">{item.title}</h4>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>

            <h3 className="mt-8 font-heading text-lg font-semibold text-foreground-950">读者怎么说</h3>
            <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
              {testimonials.map((item) => (
                <figure key={item.name} className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5">
                  <i className="ri-double-quotes-l text-xl text-accent-500"></i>
                  <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{item.text}</blockquote>
                  <figcaption className="mt-4 border-t border-background-200 pt-3">
                    <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                    <span className="block text-xs text-foreground-500">{item.role}</span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}